export default `
<html lang="en">
  <head>
    <meta charset="utf-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <META NAME="ROBOTS" CONTENT="NOINDEX, NOFOLLOW"/>
    <style type="text/css">
      body {
        padding: 0;
        margin: 0;
      }
      iframe {
        border: none
      }
    </style>
  </head>
  <body>
    <div id="container-ax" style="background:url(:backgroundUrl); background-size: 100%; padding: 10px 30px; border: 0; background-position: 0 32%; max-width: 1050px; max-height: 350px; box-sizing: border-box;" data-countryCode=":countryCode" data-affiliateCode=":affiliateCode">
      <a href=":bannerUrl" target="_blank" rel="noopener noreferrer" style="display:block;text-decoration: none;color: #fff;font-family: Arial;text-decoration: none;">
        <img src=":logoBanner" style="display:block;margin-bottom:10px;margin-top: 0px;"/>
        <div style="display:block;margin-bottom:10px;line-height: 1.5;font-size: 20px;background: #00000057;display: inline-block;padding: 0px 15px 0px 0px;"> Bis zu<br><span style="font-weight:bold;font-size: 36px;">100€</span><br><span style="font-weight:bold;color: #fee600;font-size: small;">in Wett-Credits</span><br><span>für neue Kunden</span></div>
        <span style="display:inline-block;background:#000;border:1px solid #fee600;color:#fee600;padding:5px 30px;margin-bottom:10px;font-family:Arial;">JETZT ANMELDEN</span>
        <span style="color:#fff;font-size:12px;display:block">18+ Verantwortungsbewusst spielen <br> Es gelten die AGB</span>
      </a>
    </div>
  </body>
</html>`
